export default __webpack_public_path__ + "static/3_37-47e948fccb221f258c8eb7d24ade295e.png";